import Head from 'next/head';
import { memo } from 'react';

import { TAGBrand } from '@shared-components-web/types';

const APP_PATH = process.env.APP_PATH || '/book-an-appointment';

function getAssetPath(path: string) {
	const normalizedAppPath = APP_PATH === '/' ? '' : APP_PATH.replace(/\/$/, '');

	return `${normalizedAppPath}${path}`;
}

export const fontList: Record<string, { href: string; type?: string; weight: number }[]> = {
	Lato: [
		{ href: getAssetPath('/fonts/Lato/Lato-Regular.ttf'), type: 'font/ttf', weight: 400 },
		{ href: getAssetPath('/fonts/Lato/Lato-Bold.ttf'), type: 'font/ttf', weight: 700 },
		{ href: getAssetPath('/fonts/Lato/Lato-Black.ttf'), type: 'font/ttf', weight: 900 },
	],
};

export function getFonts(_brand: TAGBrand) {
	return fontList['Lato'] ?? [];
}

export function getFontFaceStyles(brand: TAGBrand) {
	return getFonts(brand)
		.map(
			({ href, weight }) => `
				@font-face {
					font-family: 'Lato';
					src: url('${href}') format('truetype');
					font-weight: ${weight};
					font-style: normal;
					font-stretch: normal;
				}
			`
		)
		.join('');
}

export const FontPreloader = memo(function FontPreloader({ brand }: Readonly<{ brand: TAGBrand }>) {
	const fontData = getFonts(brand);
	const fontFaceStyles = getFontFaceStyles(brand);

	return (
		<Head>
			<style>{fontFaceStyles}</style>
			{fontData.map((data, i) => {
				const href = data.href as string;
				return (
					<link key={`${i}_${href}`} rel="preload" href={href} as="font" type={data.type} crossOrigin="" />
				);
			})}
		</Head>
	);
});
